import React from 'react'
import { makeStyles, Link } from '@material-ui/core'

import { SidePanel, Typography } from 'src/modules/ui'
import { formatDate, formatDateTime } from 'src/utils'

const useStyles = makeStyles(theme => ({
  sidePanelContainer: {
    flexShrink: 0,
    marginLeft: 0,
    marginTop: theme.spacing(4),
    width: 'auto',
    [theme.breakpoints.up('desktop')]: {
      marginTop: theme.spacing(9),
      marginLeft: theme.spacing(4),
      width: 250,
    },
  },
  sidePanelGroup: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: theme.spacing(2),
  },
}))

const InvoiceSidePanel = ({ children, invoice }) => {
  const classes = useStyles()

  const {
    invoiceNumber,
    invoiceDate,
    invoiceDueDate,
    creditNoteDocument,
    notes,
  } = invoice

  return (
    <div className={classes.sidePanelContainer}>
      <SidePanel>
        <div className={classes.sidePanelGroup}>
          <div>
            <Typography variant="h5">Invoice Number</Typography>
          </div>
          <div>{invoiceNumber}</div>
        </div>
        <div className={classes.sidePanelGroup}>
          <div>
            <Typography variant="h5">Invoice Date</Typography>
          </div>
          <div>{formatDate(invoiceDate)}</div>
        </div>
        {invoiceDueDate && (
          <div className={classes.sidePanelGroup}>
            <div>
              <Typography variant="h5">Invoice Due Date</Typography>
            </div>
            <div>{formatDate(invoiceDueDate)}</div>
          </div>
        )}
        {creditNoteDocument && (
          <div className={classes.sidePanelGroup}>
            <div>
              <Typography variant="h5">Credit Note</Typography>
            </div>
            <div>
              <Typography>
                <Link href={creditNoteDocument} target="_blank">
                  Download Credit Note
                </Link>
              </Typography>
            </div>
          </div>
        )}
        {notes && (
          <div className={classes.sidePanelGroup}>
            <div>
              <Typography variant="h5">Invoice Notes</Typography>
            </div>
            <div>{notes}</div>
          </div>
        )}

        {invoice.status === 'paid' && (
          <div className={classes.sidePanelGroup}>
            <div>
              <Typography variant="h5">Invoice Paid At</Typography>
            </div>
            {/* NOTE: Paid is currently the last possible action for an invoice */}
            <div>{formatDateTime(invoice.statusChangedAt)}</div>
          </div>
        )}

        {children}
      </SidePanel>
    </div>
  )
}

export default InvoiceSidePanel
